import { createStore } from 'app/createStore'
import { billing } from 'common/billing/billingService'
import { alert } from 'common/core'

import { getInitialState } from './getInitialState'
import { api } from './initMCApi'

export const store = createStore({
  thunkExtraArgument: { api, alert, billing },
  initialState: getInitialState(),
})
